export default __webpack_public_path__ + "static/media/585_1.13859baf.jpg";